import { useState } from "react";
import { materialColor } from "../materials";
import { IsoPart } from "./IsoPart";

// Compact preview for a file/project, reused across the app (project cards, file rows,
// dashboard strips). When `src` (a server-rendered PNG of the real mesh) is given it shows
// the actual geometry; otherwise it falls back to the iso "tech sample" mockup. Look only
// -- the verdict comes from the INSPECTOR, never from this thumbnail.
export function PartThumb({
  material,
  passed,
  size = 92,
  empty = false,
  src,
}: {
  material?: string | null;
  passed?: boolean | null;
  size?: number;
  empty?: boolean;
  src?: string;
}) {
  const [imgFailed, setImgFailed] = useState(false);
  const showImg = !!src && !empty && !imgFailed;
  const color = materialColor(material);
  const ring =
    passed == null ? "var(--line-2)" : passed ? "var(--ok-line)" : "var(--bad-line)";
  return (
    <div
      className="part-thumb blueprint"
      style={{
        width: size,
        height: size,
        borderRadius: 12,
        border: `1px solid ${ring}`,
        background: "radial-gradient(120% 120% at 50% 30%, #0e1828, #070b12 78%)",
        display: "grid",
        placeItems: "center",
        flexShrink: 0,
        overflow: "hidden",
        position: "relative",
      }}
    >
      {empty ? (
        <span style={{ color: "var(--muted-2)", fontFamily: "var(--font-mono)", fontSize: 10 }}>
          vide
        </span>
      ) : showImg ? (
        // Real server-rendered mesh thumbnail.
        <img
          src={src}
          alt=""
          loading="lazy"
          decoding="async"
          onError={() => setImgFailed(true)}
          style={{ width: "100%", height: "100%", objectFit: "contain", padding: size * 0.06 }}
        />
      ) : (
        // Tight, part-centred viewBox so the iso part is visually centred at any size.
        <IsoPart
          color={color}
          heatmap={false}
          reveal={1}
          section={false}
          size={size * 0.92}
          shadow={false}
          viewBox="-150 -150 300 300"
        />
      )}
      {passed != null && !empty && (
        <span
          className="dot"
          title={passed ? "Prêt à imprimer" : "Non validé"}
          style={{
            position: "absolute",
            top: 7,
            right: 7,
            color: passed ? "var(--ok)" : "var(--bad)",
          }}
        />
      )}
    </div>
  );
}
